<div class="filter-container mb-6 rounded-[12px] border p-6 filters-shadow">
  <div class="mb-6 grid grid-cols-1 gap-4 pt-4 md:grid-cols-2 lg:grid-cols-4">
    @if (!isProductLevel()) {
      <div (click)="$event.stopPropagation()">
        <app-filter-product-search
          [results]="productTitleResults()"
          [loading]="productTitleLoading()"
          [(searchTerm)]="productSearchTerm"
          [(showDropdown)]="showProductTitleDropdown"
          i18n-label="@@stock.searchProduct"
          label="Search Product"
          i18n-placeholder="@@productNameSearchPlaceholder"
          placeholder="Search products by name..."
          (searchChange)="searchChange.emit($event)"
          (selectItem)="selectProductTitle.emit($event)"
          (inputFocus)="productTitleFocus.emit()"></app-filter-product-search>
      </div>
    }

    @if (isProductLevel() && hasSubProducts()) {
      <div (click)="$event.stopPropagation()">
        <app-filter-product-search
          [results]="subProductResults()"
          [loading]="subProductLoading()"
          [(searchTerm)]="subProductSearchTerm"
          [(showDropdown)]="showSubProductDropdown"
          i18n-label="@@stock.subProduct"
          label="Sub Product Name"
          i18n-placeholder="@@stock.searchSubProduct"
          placeholder="Search sub products..."
          (searchChange)="onSubProductSearch($event)"
          (selectItem)="onSelectSubProduct($event)"
          (inputFocus)="onSubProductFocus()"></app-filter-product-search>
      </div>
    }

    @if (isCurrentStockMode()) {
      <app-filter-select-component
        i18n-label="@@stock.status"
        label="Status"
        i18n-defaultOption="@@stock.allStatus"
        defaultOption="All Status"
        [options]="[
          { id: true, titleEn: 'Activated', titleAr: 'مفعل' },
          { id: false, titleEn: 'Deactivated', titleAr: 'غير مفعل' },
        ]"
        [(value)]="filters().isActive"></app-filter-select-component>
    } @else {
      <app-filter-select-component
        i18n-label="@@stock.colType"
        label="Stock Type"
        i18n-defaultOption="@@stock.allTypes"
        defaultOption="All Types"
        [options]="stockTypes()"
        [(value)]="filters().typeId"></app-filter-select-component>
    }

    <app-filter-select-component
      i18n-label="@@stock.colSupplier"
      label="Supplier"
      i18n-defaultOption="@@stock.allSuppliers"
      defaultOption="All Suppliers"
      [options]="suppliers()"
      [(value)]="filters().supplierId"></app-filter-select-component>

    @if (isCurrentStockMode()) {
      <div class="group relative">
        <label
          i18n="@@stock.expiryFrom"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Expiry Date From
        </label>
        <input
          type="date"
          [(ngModel)]="filters().expDateFrom"
          (ngModelChange)="onExpDateFromChange($event)"
          class="w-full rounded-[10px] border bg-white px-4 py-2.5 text-[14px] transition-all outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black"
          [class.border-red-500]="dateRangeError()"
          [class.border-gray-400]="!dateRangeError()" />
      </div>

      <div class="group relative">
        <label
          i18n="@@stock.expiryTo"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
          Expiry Date To
        </label>
        <input
          type="date"
          [(ngModel)]="filters().expDateTo"
          (ngModelChange)="onExpDateToChange($event)"
          class="w-full rounded-[10px] border bg-white px-4 py-2.5 text-[14px] transition-all outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black"
          [class.border-gray-400]="!dateRangeError()" />
      </div>
    }
  </div>

  @if (dateRangeError()) {
    <p class="mb-4 px-1 text-[10px] text-red-500" i18n="@@stock.dateError">From date cannot be after To date</p>
  }
  <div class="flex flex-col items-end justify-between gap-4 border-t border-gray-300 pt-4 md:flex-row">
    <app-filter-sorting-component
      i18n-label="@@sortBy"
      [orderBy]="filters().orderBy"
      (orderByChange)="updateFilterField('orderBy', $event)"
      [orderDir]="filters().orderDir"
      [sortOptions]="stockSortOptions()"
      (toggleOrder)="toggleSortOrder.emit()"></app-filter-sorting-component>

    <div class="flex w-full justify-end gap-3 pb-1 md:w-auto">
      <button
        (click)="resetFilters.emit()"
        class="border-primary text-primary hover-bg-primary-10 cursor-pointer rounded-[6px] border px-8 py-2.5 text-[13px] font-bold transition-colors"
        i18n="@@stockfilter.reset">
        Clear
      </button>
      <button
        (click)="onApply()"
        [disabled]="dateRangeError()"
        class="bg-primary hover-bg-primary-hover cursor-pointer rounded-[6px] px-10 py-2.5 text-[13px] font-bold text-white shadow-sm transition-all disabled:opacity-50"
        i18n="@@stock.apply">
        Apply
      </button>
    </div>
  </div>
</div>
